import React from "react";
import ReusableProfileContainer from "../../directorate/ui/ReusableProfileContainer";

export default function ProfileContainer({ user, setProgress }) {
  return <ReusableProfileContainer user={user} setProgress={setProgress} />;
}
